export class LenderModel {
	id: number;
	name: string;
	lender_cap: number;
	account_cap: number;
	daily_cap: number;
	monthly_cap: number;
	lender_category: string
	lender_type: string;
	created_at: string;
	updated_at: string;
	code: string;
	email: string;
	gstin: string;
	registered_office: string;
	lender_products: any[];
}
